import en from "./lang/en";
import itLanguage from "./lang/it";

export const initI18n: any = {
    en: en,
    it: itLanguage
}
